module.exports = __webpack_public_path__ + "img/generalinvestigationBtn.6ef9f9f3.png";